import { ReactNode } from "react"
import { useWindowDimensions } from "../../../hooks/useWindowDimensions"

export function ChartRootLayout({ children }: { children: ReactNode }) {
  const windowDimensions = useWindowDimensions()

  return (
    <div
      style={{
        height: 500,
        width: windowDimensions.isSmallScreen
          ? windowDimensions.width / 1.2
          : windowDimensions.width / 2.5,
      }}
    >
      {children}
    </div>
  )
}
